import styled from 'styled-components';

/* The admin content area owns no scrollbar; each tab does, the way
   AdminUsers and the devices page do. Without this the page is clipped at
   the viewport and cannot scroll. */
export const Page = styled.div`
  height: calc(100vh - var(--title-bar-offset, 0px) - 108px);
  overflow: auto;
  padding: 0 0 48px;
  background-color: ${props => props.theme.colors.white};
`;

export const ErrorBanner = styled.p`
  ${props => props.theme.fonts.tableRow}
  color: ${props => props.theme.colors.error};
  margin: 16px 20px 0;
`;

/* What just happened, and where to go next. A toast disappears before it is
   read; this stays until dismissed and carries the link to the charts page,
   which is where the new alarm parameter becomes usable. */
export const StatusBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 16px 20px 0;
  padding: 12px 16px;
  border-radius: 4px;
  border: 1px solid ${props => props.error ? props.theme.colors.error : props.theme.primaryColor};
  background: ${props => (props.error
    ? props.theme.colors.errorBackground
    : props.theme.colors.successBackground)};
`;

export const BannerText = styled.div`
  ${props => props.theme.fonts.tableRow}
  color: ${props => props.theme.colors.greyXXD};
  strong {
    font-weight: 600;
  }
`;

export const BannerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  white-space: nowrap;
`;

export const BannerLink = styled.a`
  font-weight: 600;
  color: ${props => props.theme.primaryColor};
  cursor: pointer;
`;

export const Dismiss = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${props => props.theme.colors.greyXD};
  font-size: 16px;
  line-height: 1;
  padding: 4px;
`;

export const TableArea = styled.div`
  overflow-x: auto;
`;

/* The list of values inside one FilterBar field. */
